module.exports = __webpack_public_path__ + "static/media/ruiten.e37a5ba1.svg";